export enum AprTypeEnum {
    AUTOMATIC = 'automatic',
    MANUAL = 'manual',
}